import {Injectable} from '@angular/core';

// import {ipcRenderer} from 'electron';

@Injectable()
export class PrintService {

  constructor() {
  }

  generate_pdf_file() {
    window.print();
    // ipcRenderer.send("readyToPrintPDF");
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/services/print.service.ts